module.exports = __webpack_public_path__ + "media/images/benefits_expire_active-2ef55959.svg";